import { PlaceDto } from 'gleblu-socket-api';

import Place from '../interfaces/Place';

export function fromDto(placeDto: PlaceDto): Place {
  const { uuid, companyUuid, googlePlaceId, state, acceptsReservations, guestWebEnabled } = placeDto;
  return {
    uuid,
    companyUuid,
    googlePlaceId,
    state,
    acceptsReservations,
    guestWebEnabled,
  };
}

export function toDto(place: Place): PlaceDto {
  const { uuid, companyUuid, googlePlaceId, state, acceptsReservations, guestWebEnabled } = place;
  return {
    uuid,
    companyUuid,
    googlePlaceId,
    state,
    acceptsReservations,
    guestWebEnabled,
  };
}
